/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _pick = _interopRequireDefault(require("lodash/pick"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ProgramGuideTile = _interopRequireDefault(require("./ProgramGuideTile"));
var _gridDataHelper = require("../utils/gridDataHelper");
var _focusHelper = require("../utils/focusHelper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var navDirections = ['Left', 'Right', 'Up', 'Down'];

/**
 * A tile for showing the actual TV listings information
 * in the Program Guide grid for a given coordinate.
 *
 * The tile is given a channel range and time range based
 * on the grid coordinate it belongs to.
 *
 * Based on the ranges it renders channel lanes with program components
 * positioned based on their start and end time.
 *
 * Also supporting key navigation if used with @accedo/vdkweb-navigation
 * and focusable Program components.
 *
 * @param {object} props See propTypes
 * @returns {ProgramGuideTile} A ProgramGuideTile component
 */
var ProgramGuideTileWrapper = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ProgramGuideTileWrapper, _React$PureComponent);
  var _super = _createSuper(ProgramGuideTileWrapper);
  function ProgramGuideTileWrapper() {
    var _this;
    _classCallCheck(this, ProgramGuideTileWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    /**
     * Handles navigation behaviour for a program when
     * navigating with keys.
     * Will figure out the next program to focus
     * based on the ```direction```, ```channelIndex```
     * and ```programIndex```.
     *
     * If the program is within the given tile it will
     * focus it directly and scroll the program guide in the
     * given direction to fit the program within view.
     *
     * If we're at the edge of the tile navigating outwards,
     * it will send a navigation request up the hierarchy
     * with information on which direction to navigate and
     * which program the navigation request originated from.
     *
     * @memberof ProgramGuideTileWrapper
     *
     * @param {string} direction Navigational direction: up, down, right, left
     * @param {number} channelIndex The index of the channel holding the
     *                              currently focused program
     * @param {number} programIndex The index of the currently focused program
     * @param {bool} rtl True whether the layout has right to left direction
     * @returns {bool} Bool telling requester that the navigation is handled
     */
    _defineProperty(_assertThisInitialized(_this), "onProgramNavigation", function (direction, channelIndex, programIndex, rtl) {
      var _this$props = _this.props,
        coordinate = _this$props.coordinate,
        viewport = _this$props.viewport,
        vertical = _this$props.vertical;
      var x = coordinate.x,
        y = coordinate.y;
      var channels = _this.getChannels();
      var channel = channels[channelIndex];
      var programs = channel.programs;
      var program = programs[programIndex];
      var previousProgram = programs[programIndex - 1] || {};
      var nextProgram = programs[programIndex + 1] || {};
      if (rtl) {
        // swap next and previous so navigation match rendering for rtl
        var _ref = [previousProgram, nextProgram];
        nextProgram = _ref[0];
        previousProgram = _ref[1];
      }
      var focusProgram;
      var focusData;
      var nextChannelIndex = channelIndex;
      var toCoordinate = {
        x: x,
        y: y
      };
      var UP = vertical ? 'left' : 'up';
      var DOWN = vertical ? 'right' : 'down';
      var RIGHT = vertical ? 'down' : 'right';
      var LEFT = vertical ? 'up' : 'left';
      switch (direction.toLowerCase()) {
        case LEFT:
          focusProgram = previousProgram;
          toCoordinate.x = x - (rtl ? -1 : 1);
          break;
        case RIGHT:
          focusProgram = nextProgram;
          toCoordinate.x = x + (rtl ? -1 : 1);
          break;
        case UP:
          focusData = _this.props.getNextProgramUp(channels, channelIndex, program.startTime, program.endTime);
          nextChannelIndex = channelIndex - 1;
          toCoordinate.y = y - 1;
          break;
        case DOWN:
          focusData = _this.props.getNextProgramDown(channels, channelIndex, program.startTime, program.endTime);
          nextChannelIndex = channelIndex + 1;
          toCoordinate.y = y + 1;
          break;
        default:
          break;
      }
      if (focusData) {
        focusProgram = focusData.nextProgram;
        var _focusData = focusData;
        nextChannelIndex = _focusData.nextChannelIndex;
      }
      var navigationData = {
        fromCoordinate: coordinate,
        channelId: channel.channelId,
        program: program
      };
      if (focusProgram && focusProgram.id) {
        _this.navigateToProgram(focusProgram, nextChannelIndex);
      } else {
        _this.navigateTo({
          x: viewport.xFrom,
          y: viewport.yFrom
        }, _objectSpread(_objectSpread({}, navigationData), {}, {
          toCoordinate: toCoordinate
        }));
      }
      return true;
    });
    /**
     * Creates the navigation object holding key
     * navigation information for a program.
     * To be used with global focus management.
     *
     * @memberof ProgramGuideTileWrapper
     *
     * @param {object} program The program object to get nav info for
     * @param {number} programIndex The index of the currently focused program
     * @param {number} channelIndex The index of the channel holding the
     *                              currently focused program
     * @param {bool} rtl True whether the layout has right to left direction
     * @returns {object} Nav object to be used for global focus management
     */
    _defineProperty(_assertThisInitialized(_this), "getNavForProgram", function (program, programIndex, channelIndex, rtl) {
      var _this$props$coordinat = _this.props.coordinate,
        x = _this$props$coordinat.x,
        y = _this$props$coordinat.y;
      return {
        id: "".concat(program.id, "_").concat(x, "_").concat(y),
        internal: navDirections.reduce(function (acc, direction) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, "next".concat(direction.toLowerCase()), function next() {
            if (_this.props.focusTransitionDelayMs && _this.isDuringFocusTransition) {
              return true;
            }
            _this.setIsDuringFocusTransition(true);
            return _this.onProgramNavigation(direction, channelIndex, programIndex, rtl);
          }));
        }, {})
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getFocusProgramId", function () {
      var _this$props$coordinat2 = _this.props.coordinate,
        x = _this$props$coordinat2.x,
        y = _this$props$coordinat2.y;
      var focusInfo = _this.getFocusInfo();
      return focusInfo && focusInfo.program ? "".concat(focusInfo.program.id, "_").concat(x, "_").concat(y) : '';
    });
    _defineProperty(_assertThisInitialized(_this), "getFocusInfo", function () {
      var _this$props2 = _this.props,
        coordinate = _this$props2.coordinate,
        getProgramMatchingTime = _this$props2.getProgramMatchingTime,
        transitionInfo = _this$props2.transitionInfo;
      var channels = _this.getChannels();
      return (0, _focusHelper.getFocusInfo)({
        channels: channels,
        coordinate: coordinate,
        transitionInfo: transitionInfo,
        getProgramMatchingTimeFn: getProgramMatchingTime
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getChannels", function () {
      var data = _this.props.data;
      return data && data.content && data.content.channels || [];
    });
    _defineProperty(_assertThisInitialized(_this), "getRange", function () {
      var data = _this.props.data;
      return data && data.range || {};
    });
    /**
     * Navigates to a given program.
     * Using the X coordinate grid mapping from the program
     * and Y coordinate grid mapping from the channel index
     * to make sure the program is scrolled in to view
     * when focused.
     *
     * @param {object} program The program to navigate to
     * @param {number} channelIndex The index of the channel holding the program
     * @returns {void} Doesn't return anything
     */
    _defineProperty(_assertThisInitialized(_this), "navigateToProgram", function (program, channelIndex) {
      if (!program) {
        _this.setIsDuringFocusTransition(false);
        return;
      }
      var _this$props3 = _this.props,
        viewport = _this$props3.viewport,
        coordinate = _this$props3.coordinate,
        changeFocus = _this$props3.changeFocus;
      var range = _this.getRange();
      var _getProgramRange = (0, _gridDataHelper.getProgramRange)(program, range, coordinate),
        xFrom = _getProgramRange.xFrom,
        xTo = _getProgramRange.xTo;
      var _getChannelRange = (0, _gridDataHelper.getChannelRange)(channelIndex, range, coordinate),
        yFrom = _getChannelRange.yFrom,
        yTo = _getChannelRange.yTo;
      var x = coordinate.x,
        y = coordinate.y;
      var navigateToX = viewport.xFrom;
      var navigateToY = viewport.yFrom;
      var viewportWidth = viewport.xTo - viewport.xFrom;
      var withFixedTimeline = _this.props.withFixedTimeline;

      // Calculates the coordinate to navigate to
      // for showing the entire program in view.

      if (xFrom < viewport.xFrom) {
        navigateToX = withFixedTimeline ? Math.floor(xFrom) : xFrom;
      } else if (xTo > viewport.xTo) {
        navigateToX = withFixedTimeline ? Math.min(Math.ceil(xFrom), Math.ceil(xTo - viewportWidth)) : Math.min(xFrom, xTo - viewportWidth);
      }
      if (yFrom < viewport.yFrom) {
        navigateToY = yFrom;
      } else if (yTo > viewport.yTo) {
        navigateToY = Math.min(yFrom, yTo - viewportWidth);
      }
      _this.navigateTo({
        x: navigateToX,
        y: navigateToY
      });
      changeFocus && changeFocus("".concat(program.id, "_").concat(x, "_").concat(y));
      _this.setIsDuringFocusTransition(false);
    });
    /**
     * Requests navigation to a given coordinate
     * in the program guide coordinate grid.
     *
     * @param {object} coordinate Coordinate to navigate to
     * @param {object} navigationData Object holding navigational data
     *                                to specify where we're navigating from.
     * @returns {void}
     */
    _defineProperty(_assertThisInitialized(_this), "navigateTo", function (coordinate, navigationData) {
      var onMoveTo = _this.props.onMoveTo;
      _this.setIsDuringFocusTransition(false);
      onMoveTo && onMoveTo(coordinate, navigationData);
    });
    return _this;
  }
  _createClass(ProgramGuideTileWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
        changeFocus = _this$props4.changeFocus,
        isSelected = _this$props4.isSelected;
      if (changeFocus && isSelected) {
        var focusId = this.getFocusProgramId();
        focusId && changeFocus(focusId);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!(0, _focusHelper.isNavigatingToTile)(this.props)) {
        this.setIsDuringFocusTransition(false);
        return;
      }
      var focusInfo = this.getFocusInfo();
      if (!focusInfo) {
        return;
      }
      this.navigateToProgram(focusInfo.program, focusInfo.channelIndex);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.isDuringFocusTransitionTimeout);
    }
  }, {
    key: "setIsDuringFocusTransition",
    value: function setIsDuringFocusTransition(val) {
      var _this2 = this;
      if (val === true) {
        clearTimeout(this.isDuringFocusTransitionTimeout);
        this.isDuringFocusTransition = true;
      } else {
        clearTimeout(this.isDuringFocusTransitionTimeout);
        this.isDuringFocusTransitionTimeout = setTimeout(function () {
          _this2.isDuringFocusTransition = false;
        }, this.props.focusTransitionDelayMs);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        data = _this$props5.data,
        epgEndTime = _this$props5.epgEndTime,
        epgStartTime = _this$props5.epgStartTime;
      if (!data || !data.content || !data.range) {
        return /*#__PURE__*/_react["default"].createElement("div", null);
      }
      var _this$getRange = this.getRange(),
        startTime = _this$getRange.xFrom,
        endTime = _this$getRange.xTo,
        yTo = _this$getRange.yTo,
        yFrom = _this$getRange.yFrom;
      return /*#__PURE__*/_react["default"].createElement(_ProgramGuideTile["default"], _extends({}, (0, _pick["default"])(this.props, ['animated', 'components', 'componentsProps', 'currentTime', 'draggable', 'height', 'metadata', 'onClickProgram', 'theme', 'vertical', 'width', 'rtl']), {
        channels: this.getChannels(),
        endTime: endTime,
        epgEndTime: epgEndTime,
        epgStartTime: epgStartTime,
        firstChannelIndex: yFrom,
        getNavForProgram: this.getNavForProgram,
        lastChannelIndex: yTo,
        startTime: startTime
      }));
    }
  }]);
  return ProgramGuideTileWrapper;
}(_react["default"].PureComponent);
_defineProperty(ProgramGuideTileWrapper, "displayName", 'ProgramGuideTileWrapper');
ProgramGuideTileWrapper.propTypes = {
  changeFocus: _propTypes["default"].func,
  coordinate: _propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  }),
  data: _propTypes["default"].shape({
    content: _propTypes["default"].object,
    range: _propTypes["default"].object
  }),
  epgEndTime: _propTypes["default"].number,
  epgStartTime: _propTypes["default"].number,
  focusTransitionDelayMs: _propTypes["default"].number,
  getNextProgramDown: _propTypes["default"].func,
  getNextProgramUp: _propTypes["default"].func,
  getProgramMatchingTime: _propTypes["default"].func,
  isSelected: _propTypes["default"].bool,
  onMoveTo: _propTypes["default"].func,
  transitionInfo: _propTypes["default"].object,
  vertical: _propTypes["default"].bool,
  viewport: _propTypes["default"].shape({
    xFrom: _propTypes["default"].number,
    xTo: _propTypes["default"].number,
    yFrom: _propTypes["default"].number,
    yTo: _propTypes["default"].number
  }),
  withFixedTimeline: _propTypes["default"].bool
};
ProgramGuideTileWrapper.defaultProps = {
  focusTransitionDelayMs: 100,
  getNextProgramDown: _focusHelper.getNextProgramDown,
  getNextProgramUp: _focusHelper.getNextProgramUp
};
var _default = ProgramGuideTileWrapper;
exports["default"] = _default;